<template>
  <div class="wrapper-section">
    <slot/>

    <!-- ### Logs ### -->
    <WrapperDocRef
      v-if="showLog"
      :title="$t('message.refdoclog')"
    >
      <template #content>
        <BaseSectionDocRefLog
          :createButtonText="$t('button.addlog')"
          :logs="mapLogs"
          :refDoc="refDoc"
          :refId="refId"
          @onToggleStatus="handleClickToggleStatusLog"
          @onEdit="handleClickEditLog"
          @onDelete="handleClickDeleteLog"
          @onCreate="handleClickCreateLog"
        />
      </template>
    </WrapperDocRef>

    <!-- ### Attach Files ### -->
    <WrapperDocRef
      v-if="showAttachFile"
      :title="$t('message.refdocfile')"
    >
      <template #content>
        <BaseSectionDocRefFile
          :images="mapImages"
          :otherFiles="mapOtherFiles"
          :uploadingImages="mapUploadingImages"
          :uploadingOtherFiles="mapUploadingOtherFile"
          :createButtonText="$t('button.upload')"
          @onUploadFile="handleUploadFile"
          @onDelete="handleClickDeleteFile"
        />
      </template>
    </WrapperDocRef>

    <!-- ### Activities ### -->
    <WrapperDocRef :title="$t('message.refdocactivity')">
      <template #content>
        <BaseSectionDocRefActivity
          :activities="mapActivities"
        />
      </template>
    </WrapperDocRef>

    <!-- Modal Form Log -->
    <BaseModalDocRefLog
      :id="MODAL_FORM_LOG"
      :isSubmitted="isSubmittedFormLog"
      :initialValue="initialValueLog"
      :logTopics="logTopics"
      @onSubmit="handleSubmitFormLog"
    />

    <!-- Modal Confirm -->
    <baseConfirmDeleteModal
      :show="modalConfirmDelete.show"
      :loading="modalConfirmDelete.loading"
      @onClose="handleCloseConfirmDelete"
      @onCancel="handleCancleConfirmDelete"
      @onSubmit="handleSumitConfirmDelete"
    />
  </div>
</template>

<script>
import docRefMixin from '@/mixins/docRef'
import docRefLogMixin from '@/mixins/docRefLog'
import docRefFileMixin from '@/mixins/docRefFile'
import docRefActivityMixin from '@/mixins/docRefActivity'
import WrapperDocRef from '@/components/combine/WrapperDocRef.vue'
import BaseSectionDocRefLink from '@/components/base/BaseSectionDocRefLink.vue'
import BaseSectionDocRefLog from '@/components/base/BaseSectionDocRefLog.vue'
import BaseSectionDocRefFile from '@/components/base/BaseSectionDocRefFile.vue'
import BaseSectionDocRefActivity from '@/components/base/BaseSectionDocRefActivity.vue'
import BaseModalDocRefLog from '@/components/base/BaseModalDocRefLog.vue'

export default {
  components: {
    WrapperDocRef,
    BaseSectionDocRefLink,
    BaseSectionDocRefLog,
    BaseSectionDocRefFile,
    BaseSectionDocRefActivity,
    BaseModalDocRefLog,
  },

  mixins: [docRefMixin, docRefLogMixin, docRefFileMixin, docRefActivityMixin],
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/combine/DocRef.vue